import { EnumTipoRegime } from '../enum/EnumTipoRegime';
import { ModalidadeIrApiResponse, Regime } from '../models/modalidade-ir';

// TODO: mock temporário até a API de escolha de IR estar disponível. Remover junto com o
// USAR_MOCK_MODALIDADE_IR do HttpClientService.

const VALOR_SOLICITADO = 10500;

const REGIMES_MOCK: readonly Regime[] = [
  {
    idTipoRegime: EnumTipoRegime.Progressivo,
    aliquotaEfetiva: 15,
    valorIR: 1575,
    valorEmprestimo: 0,
    valorLiquido: 8925,
    observacao: '',
  },
  {
    idTipoRegime: EnumTipoRegime.Regressivo,
    aliquotaEfetiva: 10,
    valorIR: 1050,
    valorEmprestimo: 0,
    valorLiquido: 9450,
    observacao: '',
  },
];

/** Inteiro sorteado entre min e max (inclusive). */
function sortear(min: number, max: number): number {
  return min + Math.floor(Math.random() * (max - min + 1));
}

/**
 * Gera uma resposta diferente a cada chamada, para testar as variações da tela:
 * 1 ou 2 regimes, faixa de parcelas com min e max variáveis e pagamento único ou não.
 */
export function gerarModalidadeIrMock(): ModalidadeIrApiResponse {
  const regimes =
    Math.random() < 0.5 ? [...REGIMES_MOCK] : [REGIMES_MOCK[sortear(0, REGIMES_MOCK.length - 1)]];
  const min = sortear(1, 3);
  const max = sortear(min, 24);

  return {
    dataSimulacao: new Date().toISOString().slice(0, 10),
    tipoSimulacao: 'RESGATE',
    valorEstimadoSolicitado: VALOR_SOLICITADO,
    regimes: structuredClone(regimes),
    tipoRegimeAtual: null,
    qtdParcelaAtual: null,
    parcelas: { min, max },
    pagamentoUnico: Math.random() < 0.5,
  };
}
